import { OutboundLink } from "components/atoms/OutboundLink"
import LocalizedLink from "components/LocalizedLink"
import useTranslations from "hooks/useTranslations"
import IconSchool from "images/icon-school.svg"
import IconOffice from "images/icon-office.svg"
import Sparkles from "components/atoms/Sparkles"
import Button from "components/buttons/Button"

export default function Segments() {
  const {
    segmentsHeading,
    segmentsWorkHeading,
    segmentsWorkSubheading,
    segmentsWorkDescription,
    segmentsWorkLink,
    segmentsWorkLinkText,
    segmentsSchoolsHeading,
    segmentsSchoolsSubheading,
    segmentsSchoolsDescription,
    segmentsSchoolsLink1,
    segmentsSchoolsLink1Text,
  } = useTranslations()

  const segments = [
    {
      title: segmentsWorkHeading,
      subtitle: segmentsWorkSubheading,
      links: [
        {
          text: segmentsWorkLinkText,
          href: segmentsWorkLink,
        },
      ],
      description: segmentsWorkDescription,
      icon: IconOffice,
    },
    {
      title: segmentsSchoolsHeading,
      subtitle: segmentsSchoolsSubheading,
      links: [
        {
          text: segmentsSchoolsLink1Text,
          href: segmentsSchoolsLink1,
        },
      ],
      description: segmentsSchoolsDescription,
      icon: IconSchool,
    },
  ]

  return (
    <div className="bg-zinc-800">
      <div className="relative mx-auto max-w-7xl space-y-16 px-4 py-16 sm:px-6 lg:px-8 lg:py-24">
        <div className="">
          <Sparkles>
            <h1 className="m-0 mb-2 max-w-5xl whitespace-pre-line text-3xl font-extrabold tracking-tight text-neutral-100 md:text-4xl lg:mb-4 lg:text-5xl">
              {segmentsHeading}
            </h1>
          </Sparkles>
        </div>

        <div className="grid grid-cols-1 gap-y-12 lg:grid-cols-2 lg:gap-x-16 lg:gap-y-0">
          {segments.map((segment) => (
            <div key={segment.title} className="flex flex-col ">
              <div className="flex-1">
                <div className="flex flex-row space-x-3">
                  <div className="grow">
                    <h3 className="m-0">
                      <span className="block text-2xl font-medium text-white md:mb-2 md:text-3xl">
                        {segment.title}
                      </span>
                      <span className="text-xl font-medium leading-5 text-primaryAccent">
                        {segment.subtitle}
                      </span>
                    </h3>
                  </div>
                  <div className="-translate-y-2 transform lg:-translate-y-0">
                    <segment.icon
                      className="w-20 text-sb-darkGreen"
                      aria-hidden="true"
                    />
                  </div>
                </div>
                <p className="m-0 mt-4 text-base text-zinc-100">
                  {segment.description}
                </p>
              </div>
              <div className="py-6">
                {segment.links.map(({ text, href }) => (
                  <div className="inline-block pr-3 text-base font-medium text-kkm-green hover:text-kkm-darkgreen">
                    <LocalizedLink to={href} />
                    <Button link={href} label={text} size="md" />
                  </div>
                ))}
              </div>
            </div>
          ))}
        </div>
      </div>
    </div>
  )
}
